<div
    [ngClass]="separateDialCodeClass"
    style="height: 100%;"
>
    <nz-input-group
        [nzAddOnBefore]="addOnBeforeTemplate"
        style="height: 100%;"
    >
        <input
            style="padding: 0 0 2px 0; height: 100%;"
            type="tel"
            nz-input
            mask="(000) 000-0000"
            [nzBorderless]="borderless"
            autocomplete="tel-national"
            (blur)="onTouched()"
            [(ngModel)]="phoneNumber"
            (ngModelChange)="onPhoneNumberChange()"
            [disabled]="disabled"
            [placeholder]="placeholder"
            #focusable
        />
    </nz-input-group>
    <ng-template #addOnBeforeTemplate>
        <nz-select
            style="min-width: 40px; height: 100%;"
            nzShowSearch
            nzAllowClear
            autocomplete="tel-country-code"
            nzPlaceHolder="+1"
            class="phone-input-country-select"
            [nzBorderless]="borderless"
            [compareWith]="compareFn"
            [nzFilterOption]="filterFn"
            [(ngModel)]="selectedCountry"
            (ngModelChange)="onCountrySelect(focusable)"
            [disabled]="disabled"
        >
            <nz-option
                *ngFor="let country of preferredCountriesInDropDown"
                class="iti__country iti__standard"
                nzCustomContent
                [nzLabel]="'+' + country.dialCode"
                [nzValue]="country"
                [id]="country.htmlId + '-preferred'"
            >
                <span class="iti__country-name">{{ country.name }} </span>
                <span class="iti__dial-code"> +{{ country.dialCode }}</span>
            </nz-option>

            <nz-option-group nzLabel="All countries">
                <nz-option
                    *ngFor="let country of allCountries"
                    class="iti__country iti__standard"
                    nzCustomContent
                    [nzLabel]="'+' + country.dialCode"
                    [nzValue]="country"
                    [id]="country.htmlId"
                >
                    <span class="iti__country-name">{{ country.name }} </span>
                    <span class="iti__dial-code"> +{{ country.dialCode }}</span>
                </nz-option>
            </nz-option-group>
        </nz-select>
    </ng-template>
</div>